import Select from "react-select";
import { useElement, useLocale, useService } from "../../../hooks";
import { useBookServiceForm } from "./hooks";
import "./style.scss";
export const BookServiceForm = () => {
  const { t } = useLocale();
  const Button = useElement("Button");
  const { isEmpty } = useService("Misc");
  const {
    carBrands,
    carModels,
    services,
    locations,
    activeCarBrand,
    activeCarModel,
    activeService,
    activeLocation,
    bookService,
    selectCarBrand,
    selectCarModel,
    selectService,
    selectLocation,
  } = useBookServiceForm();
  return (
    <form className="book-service-form" noValidate onSubmit={bookService}>
      <h1>{t("bookServiceTitle")}</h1>
      <Select
        value={activeCarBrand}
        defaultValue={activeCarBrand}
        onChange={selectCarBrand}
        options={carBrands}
        placeholder={t("placeholder.carBrand")}
      />
      <Select
        value={activeCarModel}
        isDisabled={isEmpty(activeCarBrand)}
        defaultValue={activeCarModel}
        onChange={selectCarModel}
        options={carModels}
        placeholder={t("placeholder.carModel")}
      />
      <Select
        value={activeService}
        isDisabled={isEmpty(activeCarModel)}
        defaultValue={activeService}
        onChange={selectService}
        options={services}
        placeholder={t("placeholder.service")}
      />
      <Select
        value={activeLocation}
        isDisabled={isEmpty(activeService)}
        defaultValue={activeLocation}
        onChange={selectLocation}
        options={locations}
        placeholder={t("placeholder.location")}
      />
      <div className="flex mb0">
        <Button
          disabled={isEmpty(activeLocation)}
          onClick={bookService}
          className="btn btn-primary mauto"
        >
          {t("bookServiceCTA")}
        </Button>
      </div>
    </form>
  );
};
